import { Resource as a, API as i } from "@coveo/platform-client";
const r = class r extends a {
  /**
   * Preview the impact of creating a rule.
   * @param previewRequest Information about the rule to preview.
   * @param ruleId The ID of the rule being previewed. If not provided, the rule is assumed to be new.
   * @returns The products that would be returned.
   */
  preview(s, e) {
    return this.api.post(this.buildPath(r.baseUrl, { ruleId: e }), s);
  }
};
r.baseUrl = `/rest/organizations/${i.orgPlaceholder}/commerce/private/preview`;
let t = r;
export {
  t as RulePreview
};
//# sourceMappingURL=RulePreview.js.map
